define([
    'common/ui/view/svg/util',
    'common/ui/view/svg/index'
], function(
    SVGUtil,
    SVGView
    ) {
    /**
     * SVG Root class.
     *
     * @exports views/svg/frame-view
     * @example
     * require(['balus/views/svg/frame-view'], function(FrameView) {
     *     var canvas = new RootView(opts);
     * };
     */
    var RootView = SVGView.extend({
        tagName: 'svg',

        /**
         * @constructs
         * @extends SVGView
         *
         * @param {Boolean} [opts.centerOrigin=false] - if true center of the ViewPort becomes origin=(0,0).
         * @param {Number} opts.viewPort.width
         * @param {Number} opts.viewPort.height
         */
        initialize: function(opts) {
            RootView.__super__.initialize.call(this, opts);
            this._viewPort = opts.viewPort;
            this._centerOrigin = opts.centerOrigin ? true : false;
        },

        render: function() {
            this.$el
                .attr('pointer-events', 'all');
            this._setViewPort();

            return this;
        },

        resize: function(viewPort) {
            this._viewPort = viewPort;
            this._setViewPort();
        },

        _setViewPort: function() {
            this.$el
                .attr('width', this._viewPort.width)
                .attr('height', this._viewPort.height);

            if(this._centerOrigin) {
                const x = - this._viewPort.width / 2;
                const y = - this._viewPort.height / 2;
                const width = this._viewPort.width;
                const height = this._viewPort.height;
                this.$el
                    .attr('viewBox', `${x} ${y} ${width} ${height}`);
            }
        },

        getViewPort: function() {
            return this._viewPort;
        }
    });

    return RootView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/root.js